/**
 * 图片效果刷：选中为图片层时展示，复制图片效果数据并触发 imageBrush 埋点。
 */
import React from 'react';
import { getLocaleStore } from '@/i18n';
import { type ShortcutMenu } from '@/plugins/shortcut-menu/shortcut-menu';
import { SHORTCUT_FUNC_MAP, type IShortcutMenuItemRenderArgs } from '@/plugins/shortcut-menu/type';
import { ShortcutToolbarIconItem } from '@/plugins/shortcut-menu/views/shortcut-toolbar-widgets';
import { LayerType } from '@/version-types';
import { type ImageEffectPlugin } from '../../../..';

export const imageFormatBrushShortcutItem = ({ framework, activePickLayer }: IShortcutMenuItemRenderArgs) => {
    const { $t } = getLocaleStore();
    if (activePickLayer?.layerType !== LayerType.IMAGE_LAYER) return null;

    return (
        <ShortcutToolbarIconItem
            name="FormatPainterBold"
            title={$t((v) => v.baseLayer.shortcutOperate.copyEffect)}
            onClick={(e) => {
                e.stopPropagation();
                const imageEffect = framework.service.registration.getInstance<ImageEffectPlugin>('ImageEffectPlugin');
                if (!imageEffect) {
                    throw new Error('ImageEffectPlugin is not found');
                }
                const started = imageEffect.setImageBrush(
                    activePickLayer.id,
                    $t((v) => v.baseLayer.shortcutOperate.cursorTip),
                );
                if (!started) return;
                framework.service.registration
                    .getInstance<ShortcutMenu>('ShortcutMenu')
                    .emitClick(SHORTCUT_FUNC_MAP.imageBrush);
            }}
        />
    );
};
